import { gql } from 'graphql-request';

import {
  SelectedLifestyleDownloadUrlsClassName,
  SelectedLifestyleDownloadUrlsID,
  SelectedLifestyleDownloadUrlsType,
  SelectedLifestyleDownloadUrlsUrl,
  SelectedLifestyleDownloadUrlsUUID,
  SelectedLifestyleID,
  SelectedLifestyleUUID
} from '../selectedLifestylesTypes';

export interface FetchSelectedLifestyleDownloadUrlsQueryResponse {
  id: SelectedLifestyleID;
  uuid: SelectedLifestyleUUID;
  downloadUrls: {
    url: SelectedLifestyleDownloadUrlsUrl;
    id: SelectedLifestyleDownloadUrlsID;
    uuid: SelectedLifestyleDownloadUrlsUUID;
    type: SelectedLifestyleDownloadUrlsType;
    className: SelectedLifestyleDownloadUrlsClassName;
  }[];
}

export const FETCH_SELECTED_LIFESTYLE_DOWNLOAD_URLS_QUERY = gql`
  query SelectedLifestyleDownloadUrls($uuid: ID!) {
    selectedLifestyle(uuid: $uuid) {
      id
      uuid
      downloadUrls {
        className
        url
        id
        uuid
        type
      }
    }
  }
`;
